'use client'

import { useEffect } from 'react'
import Script from 'next/script'

import { type ProductItem } from '../../ProductProvider'

interface ReviewProps {
  config: {
    isV3ReviewsWidget: boolean
    reviews_instance_id: string
    yotpo_widget_url: string
  }
  product: ProductItem
}

declare global {
  interface Window {
    yotpoWidgetsContainer:
      | {
          initWidgets: () => void
          initWidget: (instanceId: string) => void
        }
      | undefined
  }
}

const Review = ({ config, product }: ReviewProps) => {
  useEffect(() => {
    if (window?.yotpoWidgetsContainer && window?.yotpoWidgetsContainer?.initWidgets) {
      window?.yotpoWidgetsContainer?.initWidgets()
    }
  }, [config, product])
  return (
    <>
      <Script strategy="lazyOnload" src={`${config.yotpo_widget_url}`}></Script>
      {config.isV3ReviewsWidget ? (
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={config.reviews_instance_id}
          data-yotpo-product-id={product?.id}
          data-yotpo-name={product?.name}></div>
      ) : (
        <div
          className="yotpo yotpo-main-widget"
          data-product-id={product?.id}
          data-name={product?.name}></div>
      )}
    </>
  )
}

export default Review
